import React, { useState, useEffect } from "react";
import { Page, Icon, Link, Preloader } from "framework7-react";
import axios from "axios";
import { API_BASE_URL, API_AUTH, IMG_URL } from "./../globals";

const CuisinelistingPage = ({ f7route }) => {
  const { cid } = f7route.params;
  const [restdata, setRestDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // State to control loading indicator
  const [showNoResult, setShowNoResult] = useState(false); // State to control the "No Result Found" message

  useEffect(() => {
    axios
      .get(API_BASE_URL + "restaurantdetails", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: { cuisine: cid },
      })
      .then((response) => {
        if (response.status === 200 && response.data.length > 0) {
          // Data is available, set it and hide the loading indicator
          setRestDetails(response.data);
          setIsLoading(false);
          setShowNoResult(false);
        } else {
          // No data found, hide the loading indicator and show the "No Result Found" message
          setRestDetails([]);
          setIsLoading(false);
          setShowNoResult(true);
        }
      })
      .catch((error) => {
        // Handle the 404 error
        if (error.response && error.response.status === 404) {
          setRestDetails([]);
          setIsLoading(false);
          setShowNoResult(true);
        } else {
          console.log(error);
        }
      });
  }, [cid]);
  return (
    <Page className="bg-white">
      <div className="container container-table">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="container-lg custom-container p-0">
              <div className="header-panel">
                <Link href="#" back reloadAll>
                  <Icon
                    ios="material:keyboard_arrow_left"
                    aurora="material:keyboard_arrow_left"
                    md="material:keyboard_arrow_left"
                    className="theme-dark"
                    backLink="Back"
                  ></Icon>
                </Link>
                <h2>{restdata.map((item) => item.cuisine_name)[0]} Cuisine</h2>
              </div>
            </div>
          </header>
          <section className="section-t-space section-b-space profile-form mt-3">
            <div className="custom-container p-0">
              {isLoading ? (
                <div className="text-center mt-5">
                  <Preloader color="orange" />
                </div>
              ) : (
                <div className="row gy-3">
                  {restdata.length ? (
                    restdata.map((restdetail) => (
                      <div className="bid-web-view-div">
                        <a href={`/restaurantdetail/${restdetail.rest_id}/`}>
                          <div className="vertical-product-box restaurant-product-box">
                            <div className="vertical-box-img">
                              <a
                                href={`/restaurantdetail/${restdetail.rest_id}/`}
                              >
                                {restdetail.rest_img !== null ? (
                                  <img
                                    className="img-fluid img"
                                    src={`${IMG_URL}${restdetail.rest_img}`}
                                    alt={restdetail.rest_name}
                                    style={{ height: "120px", width: "100%" }}
                                  />
                                ) : (
                                  <img
                                    className="img-fluid img"
                                    src={require("./../images/no-image.png")}
                                    alt={restdetail.rest_name}
                                    style={{ height: "120px", width: "100%" }}
                                  />
                                )}
                              </a>
                              <div className="like-icon">
                                {/* <i className="ri-heart-3-line outline-icon" /> */}
                                <i className="ri-heart-3-fill fill-icon" />
                                <div className="effect-group">
                                  <span className="effect" />
                                  <span className="effect" />
                                  <span className="effect" />
                                  <span className="effect" />
                                  <span className="effect" />
                                </div>
                              </div>
                            </div>
                            <div className="vertical-box-details">
                              <div className="vertical-box-head">
                                <div className="restaurant">
                                  <a
                                    href={`/restaurantdetail/${restdetail.rest_id}/`}
                                  >
                                    <h5>{restdetail.rest_name}</h5>
                                  </a>
                                </div>
                                <h6 className="food-items text-capitalize">
                                  {/* {restdetail.menu_details.map(menu => (
                                    menu.menu_item_name + ', '
                                  ))} */}
                                  {restdetail.cuisine_name}
                                </h6>
                              </div>
                              <div className="location-distance">
                                <div className="location1">
                                  <p className="place text-secondary mt-1">
                                    <Icon
                                      ios="material:location_on"
                                      aurora="material:location_on"
                                      md="material:location_on"
                                      size={16}
                                      className="text-success"
                                    ></Icon>{" "}
                                    {restdetail.add_lin_1}{" "}
                                    {restdetail.add_lin_2} {restdetail.city}{" "}
                                    {restdetail.state} {restdetail.zip_code}
                                  </p>
                                  {/* <h6 className="pt-2 pb-2 text-dark">Start from <span className="text-danger">$545</span> for one tray</h6> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    ))
                  ) : showNoResult ? (
                    <div className="custom-container p-0">
                      <div className="empty-tab">
                        <img
                          className="img-fluid empty-search w-100"
                          src="https://themes.pixelstrap.com/zomo-app/assets/images/empty-search.svg"
                          alt="empty-search"
                        />
                        <h2 className="text-4">No Restaurant</h2>
                      </div>
                    </div>
                  ) : null}
                </div>
              )}
            </div>
          </section>
        </div>
      </div>
    </Page>
  );
};

export default CuisinelistingPage;
